import { Entity, EntityEdge, EntityMap } from '@ms/yammer-data-support';
import { NetworkSearchScopeType, NetworkSearchUserResultFilterType } from '@ms/yammer-graphql';

import { Group } from '../groups/types';
import { Network, Thread } from '../types';

export enum SearchResultType {
  Thread = 'Thread',
  Group = 'Group',
  User = 'User',
  File = 'File',
  Inbox = 'Inbox',
  Topic = 'Topic',
  NetworkQuestion = 'NetworkQuestion',
  PublisherNetworkQuestion = 'PublisherNetworkQuestion',
  Campaign = 'Campaign',
}

export enum SearchboxSourceType {
  MsTeamsSearch = 0,
  Publisher = 1,
  MainSearch = 2,
  DiscoverTopics = 3,
  SerpSessionEnforcement = 4,
}

export interface SearchLocationParameters {
  readonly searchText: string;
  readonly resultType: SearchResultType;
  readonly groupScope?: Group['id'];
  readonly startTimestamp?: number;
  readonly endTimestamp?: number;
  readonly networkScopeType?: NetworkSearchScopeType;
  readonly networkIds?: Network['id'][];
  readonly userResultFilters?: NetworkSearchUserResultFilterType[];
}

export interface SearchParameters extends SearchLocationParameters {
  readonly locale: string;
}

export interface SearchLoadMoreParameters extends SearchParameters {
  readonly afterCursor?: string;
}

export type SearchResultEdge = EntityEdge<Entity> & { readonly cursor: string };

export interface SearchResultsForType extends Entity {
  readonly id: string;
  readonly results: SearchResultEdge[];
  readonly hasNextPage: boolean;
  readonly endCursor?: string;
}

export interface NetworkQuestionSearchResult extends Entity {
  readonly id: string;
  readonly results: SearchResultEdge[];
  readonly hasNextPage: boolean;
  readonly endCursor?: string;
}

export interface NetworkQuestionPublisherSearchResult extends Entity {
  readonly id: string;
  readonly results: SearchResultEdge[];
}

export type Searches = EntityMap<SearchResultsForType>;

export class SearchResultThreadRenderError extends Error {
  public threadId: Thread['id'];

  constructor(error: Error, threadId: Thread['id']) {
    super();

    this.threadId = threadId;
    this.message = error.message;
    this.stack = error.stack;

    Object.setPrototypeOf(this, SearchResultThreadRenderError.prototype);
  }
}
